import Icon from '@/components/ui/AppIcon';

interface TrustIndicatorsProps {
  indicators: {
    awards: { name: string; year: string; icon: string }[];
    certifications: { name: string; issuer: string }[];
    mediaFeatures: { outlet: string; title: string }[];
  };
}

const TrustIndicators = ({ indicators }: TrustIndicatorsProps) => {
  return (
    <div className="bg-card rounded-lg shadow-card p-6 lg:p-8 mb-8">
      <h2 className="font-heading font-bold text-2xl text-foreground mb-6 text-center">
        Industry Recognition & Trust Signals
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center space-x-2 mb-4">
            <Icon name="TrophyIcon" size={20} variant="solid" className="text-cta" />
            <h3 className="font-heading font-semibold text-base text-foreground">
              Awards & Recognition
            </h3>
          </div>
          <div className="space-y-3">
            {indicators.awards.map((award, index) => (
              <div key={index} className="flex items-start space-x-3 p-3 bg-muted/30 rounded-lg">
                <div className="text-2xl">{award.icon}</div>
                <div>
                  <p className="text-sm font-medium text-foreground">{award.name}</p>
                  <p className="text-xs text-muted-foreground">{award.year}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-2 mb-4">
            <Icon name="ShieldCheckIcon" size={20} variant="solid" className="text-success" />
            <h3 className="font-heading font-semibold text-base text-foreground">
              Certifications & Compliance
            </h3>
          </div>
          <div className="space-y-3">
            {indicators.certifications.map((cert, index) => (
              <div key={index} className="flex items-start space-x-3 p-3 bg-success/5 rounded-lg border border-success/20">
                <Icon name="CheckBadgeIcon" size={20} variant="solid" className="text-success flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-foreground">{cert.name}</p>
                  <p className="text-xs text-muted-foreground">{cert.issuer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-2 mb-4">
            <Icon name="NewspaperIcon" size={20} variant="solid" className="text-primary" />
            <h3 className="font-heading font-semibold text-base text-foreground">
              Media Features
            </h3>
          </div>
          <div className="space-y-3">
            {indicators.mediaFeatures.map((feature, index) => (
              <div key={index} className="p-3 bg-primary/5 rounded-lg border border-primary/20">
                <p className="text-sm font-medium text-primary">{feature.outlet}</p>
                <p className="text-xs text-muted-foreground mt-1">{feature.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;